import { useRouter } from 'next/router'
import classNames from 'classnames'
import React from 'react'
import { loggedInNavLinksWithFnO } from './utils/navigation-items'
import Link from '@/components/Common/Link'
import { DASHBOARD_HEADER_NAV_CLICK } from '@/root/utils/common/web/gtm-events/eventsList'
import { useAnalyticsEvent } from '@/hooks/analytics/use-analytics-event'
import Text from '@/stories/components/Common/NewText'
import NewTabSvg from '@/stories/assets/common/new-tab.inline.svg'

const isSelected = (
  pathname: string = '',
  type: (typeof loggedInNavLinksWithFnO)[number]['type'],
) => {
  return pathname.includes(type)
}

// NOTE: Now this Desktop Navigation Component in only used for Authenticated state

export default function HeaderNavigation({ host }: { host?: string }) {
  const router = useRouter()
  const { pathname } = router

  const pushEvent = useAnalyticsEvent()

  const navlinks = loggedInNavLinksWithFnO?.filter(
    el => !el.dontShowOn?.find(el => el.host === host),
  )

  const loggedInJSX = (
    <ul className="flex items-center">
      {navlinks.map(({ link, text, type, openingInNewTab, icon, title }) => {
        const Icon = icon as React.ElementType
        const onlyIcon = !text && !openingInNewTab

        return (
          <Link
            onClick={() =>
              pushEvent({
                mixpanelEventPayload: {
                  eventName: DASHBOARD_HEADER_NAV_CLICK,
                  payload: {
                    cta_name: text ?? title,
                    url: link,
                  },
                },
              })
            }
            key={link}
            href={link}
            title={text ?? title}
            openInNewTab={openingInNewTab}
            className={classNames(
              'flex  gap-x-1 rounded-lg p-2.5 text-brand-grey-dark hover:bg-brand-tertiary-grey ',
              {
                'font-medium !text-brand-blue-azureRadiance': isSelected(
                  pathname,
                  type,
                ),
                '!rounded-full !p-2': onlyIcon,
                'items-center': !openingInNewTab,
              },
            )}
          >
            {text && <Text appearance="body1">{text}</Text>}
            {icon && (
              <Icon
                className={classNames('h-5 w-5', {
                  '!h-3 !w-3': onlyIcon,
                })}
              />
            )}
            {openingInNewTab && (
              <NewTabSvg className="h-2.5 w-2.5 text-brand-grey-light" />
            )}
          </Link>
        )
      })}
    </ul>
  )

  return <nav className="h-full">{loggedInJSX}</nav>
}
